import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { flow } from 'lodash/fp';
import { filterByMultipleConditions } from '../utilities/filter';

export const useActivityFilters = (
  allActivities = [],
  activityFilters = []
) => {
  const { enabledFilters } = useSelector((state) => ({
    enabledFilters: state.activity.enabledFilters,
  }));

  const filteredActivities = useMemo(() => {
    if (!Array.isArray(allActivities) || allActivities.length === 0) {
      return [];
    }

    if (enabledFilters.length === 0 || !Array.isArray(activityFilters)) {
      return allActivities;
    }

    const predicates = activityFilters
      .filter((f) => f && f.name && enabledFilters.includes(f.name))
      .map((f) => f.predicate)
      .filter(Boolean);

    if (predicates.length === 0) {
      return allActivities;
    }

    try {
      return flow([filterByMultipleConditions(predicates)])(allActivities);
    } catch (error) {
      console.warn('Error filtering activities:', error);
      return allActivities; // Fallback to unfiltered
    }
  }, [allActivities, enabledFilters, activityFilters]);

  return {
    filteredActivities,
    enabledFilters,
    hasActiveFilters: enabledFilters.length > 0,
  };
};

export default useActivityFilters;
